<div>
  <mat-checkbox [checked]="graticuleVisibilitySignal()" (change)="updateGraticule($event.checked)">
    Show Graticule
  </mat-checkbox>
</div>

<div>
  <mat-form-field appearance="outline">
    <mat-label>Map Units</mat-label>
    <mat-select [value]="mapScaleUnitSignal()" (selectionChange)="updateMapScale($event.value)">
      @for (option of MapScaleOptions; track option.value) {
        <mat-option [value]="option.value">
          {{ option.text }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

@if (routeDataSignal().length > 0) {
  <div>
    <mat-form-field appearance="outline">
      <mat-label>KP Spacing (km)</mat-label>
      <input
        #KpSpacing
        matInput
        type="number"
        [value]="kpSpacingSignal()"
        (input)="updateKpSpacing(+KpSpacing.value)"
      />
    </mat-form-field>
  </div>
}

@if (kpSpacingSignal() > 0 && kpActionStateSignal().totalKPFeatures > 0) {
  <div class="control-buttons">
    <button
      mat-icon-button
      (click)="kpActionButton('prev')"
      [disabled]="kpActionStateSignal().clickedKpIndex <= 0"
      matTooltip="Zoom to previous KP"
    >
      <mat-icon>{{ arrowBackIcon }}</mat-icon>
    </button>
    <button mat-icon-button (click)="kpActionButton('first')" matTooltip="Zoom to first KP">
      <mat-icon>{{ zoomInMapIcon }}</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="kpActionButton('next')"
      [disabled]="kpActionStateSignal().clickedKpIndex >= kpActionStateSignal().totalKPFeatures - 1"
      matTooltip="Zoom to next KP"
    >
      <mat-icon>{{ arrowForwardIcon }}</mat-icon>
    </button>
  </div>
}

@if (routeDataSignal().length > 0) {
  <div>
    <button mat-stroked-button (click)="exportGeoJson()" mat-tooltip="Download GeoJSON">
      <mat-icon>{{ fileDownloadIcon }}</mat-icon>
      Route Data GeoJSON
    </button>
  </div>
}
